<div class="custom-container">
  <app-breadcrumb [item]="breadcrumbs"></app-breadcrumb>

  <div class="row">
    <div class="col-10">
      <p class="text-000000 text-montserrat text-600 text-18 mb-0">
        Listado de las Acciones de Capacitación en ejecución
      </p>
      <p class="text-000000 text-nunito text-400 text-14">
        Acceda al detalle de cada actividad desde la grilla y realice el seguimiento y toma de asistencia.
      </p>
    </div>

    <div class="col-2 d-flex align-items-end justify-content-end">
      <button class="btn btn-filtrar">
        <img src="assets/icons/filtrar.svg" alt="" class="me-1">
        Filtrar
      </button>
    </div>

    <div class="col-12 mt-3">
      <table class="table table-asistencia">
        <thead>
          <tr>
            <th class="text-center" style="width: 100px;">Código AC</th>
            <th class="text-left">Acción de Capacitación</th>
            <th class="text-left">Curso</th>
            <th class="text-center">Fecha Inicio</th>
            <th class="text-center">Fecha Fin</th>
            <th class="text-center">Estado</th>
            <th class="text-center">Opciones</th>
          </tr>
        </thead>
        <tbody>
          @if (accs.length === 0) {
          <tr>
            <td colspan="7" class="text-center">No se encontraron registros</td>
          </tr>
          }
          @for (acc of accs; track acc.acca_id) {
          <tr>
            <td class="text-center">{{ acc.acca_id }}</td>
            <td class="text-left">{{ acc.acca_nombre }}</td>
            <td class="text-left">{{ acc.cuse_nombre }}</td>
            <td class="text-center">{{ acc.even_inicio_ejecucion }}</td>
            <td class="text-center">{{ acc.even_fin_ejecucion }}</td>
            <td class="text-center">
              <div class="w-100 d-flex justify-content-center">
                <div class="badge-table text-truncate" [ngClass]="
                      acc.estado.id == 1 ? 'grey' :
                      acc.estado.id == 2 ? 'green' : 
                      acc.estado.id == 3 ? 'blue' : 'white'">
                  {{
                  acc.estado.id == 1 ? 'Por Iniciar' :
                  acc.estado.id == 2 ? 'En Curso' :
                  acc.estado.id == 3 ? 'Finalizado' :
                  'No definido'
                  }}
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="dropdown">
                <button class="btn btn-vacio" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                  <img src="assets/icons/opciones.svg" alt="">
                </button>
                <ul class="dropdown-menu p-0 border shadow" aria-labelledby="dropdownMenuButton">
                  <li><a class="dropdown-item cursor-pointer py-2" (click)="goGestionarAsistencia(acc.acca_id);">
                    <div class="d-flex align-items-center">
                      <img src="assets/icons/gestionar-asistencia.svg" alt="" width="19px" height="19px"/>
                      <span class="text-nunito text-400 text-13 ms-2">Gestionar asistencia</span>
                    </div>
                  </a></li>
                </ul>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="col-12">
      <app-pagination [totalRows]="totalAccs" [pageSize]="pageSize" [pageSizes]="pageSizes" [currentPage]="currentPage"
        (pageChange)="onPageChange($event)" (pageSizeChange)="changePageSize($event)">
      </app-pagination>
    </div>

    <div class="col-12 d-flex justify-content-end my-5">
      <button class="btn btn-volver" (click)="goHome()">Volver</button>
    </div>
  </div>
</div>